import { Link } from '@tanstack/react-router'

interface BlogPostBreadcrumbProps {
  slug: string
}

const LINK =
  'rounded-sm transition-colors hover:text-[var(--color-text-primary)] focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-primary/50'

export function BlogPostBreadcrumb({ slug }: BlogPostBreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-8 flex flex-wrap items-center gap-2 font-mono text-caption text-[var(--color-text-tertiary)]"
    >
      <Link to="/" className={LINK}>
        home
      </Link>
      <span aria-hidden>/</span>
      <Link to="/blogs" search={{ page: 1 }} className={LINK}>
        blog
      </Link>
      <span aria-hidden>/</span>
      <span className="truncate text-[var(--color-text-secondary)]">{slug}</span>
    </nav>
  )
}
